import api from '../../api'
import Constants from '../../constants'

const getDefaultState = () => {
  return {
    all: [],
    title: '',
    editable: false,
    isUser: false
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => {
    return state.all
  },
  isOwner: (state) => state.editable,
  getTitle: (state) => state.title,
  getIsUser: (state) => state.isUser
}

const actions = {
  fetchAll ({ rootGetters, commit }) {
    return new Promise((resolve) => {
      if (rootGetters['user/getToken'] !== null) {
        api.getPlans(rootGetters['user/getToken'], rootGetters['user/getLang'])
          .then((plans) => {
            commit('setIsUser', true)
            commit('setPlans', plans)
            resolve()
          })
          .catch(() => {
            commit('setIsUser', false)
          })
      }
    })
  },
  createToken ({ dispatch, commit }) {
    return new Promise((resolve) => {
      api.createToken()
        .then((data) => {
          dispatch('user/setTokenAndRecoveryCode', data, { root: true })
          commit('setIsUser', true)
          resolve()
        })
    })
  },
  recoveryToken ({ dispatch, rootGetters, commit }, recoveryCode) {
    return new Promise((resolve) => {
      api.recoveryToken(recoveryCode)
        .then((data) => {
          dispatch('user/setTokenAndRecoveryCode', data, { root: true })
          api.getPlans(data.token, rootGetters['user/getLang'])
            .then((plans) => {
              commit('setIsUser', true)
              commit('setPlans', plans)
              const params = {
                token: data.token,
                id: Constants.API_ID
              }
              api.getUserProfile(params)
                .then((data) => {
                  dispatch('user/setProfile', data, { root: true })
                  resolve()
                })
            })
            .catch(() => {
              commit('setIsUser', false)
            })
        })
    })
  },
  save ({ commit, state, rootGetters }, id) {
    const condition = rootGetters['condition/getOptions']
    const stations = rootGetters['destinations/getStations']
    const destinations = rootGetters['destinations/getAll']
    const routes = rootGetters['routes/getAll']
    const token = rootGetters['user/getToken']
    const serviceId = Constants.API_ID
    const params = {
      serviceId: serviceId,
      title: state.title,
      datetime: routes[0].departureTime.format('YYYY-MM-DD'),
      items: { condition, stations, destinations, routes},
      token: token
    }
    if (id) Object.assign(params, { id: id })

    return new Promise((resolve, reject) => {
      api.savePlan(params)
        .then((id) => {
          commit('saveDone')
          resolve(id)
        })
        .catch(() => {
          reject()
        })
    })
  },
  fetchPlan ({ dispatch, commit, rootGetters }, id) {
    const params = {
      id: id,
      token: rootGetters['user/getToken']
    }

    return new Promise((resolve, reject) => {
      api.getPlan(params)
        .then((plan) => {
          dispatch('condition/updateOptions', plan.items.condition, { root: true })
          dispatch('routes/updateRoutes', plan.items.routes, { root: true })
          dispatch('destinations/updateDestinations', plan.items.destinations, { root: true })
          dispatch('destinations/updateStations', plan.items.stations, { root: true })
          commit('setPlan', plan)
          resolve()
        })
        .catch(() => {
          reject()
        })
    })
  },
  deletePlan ({ commit, rootGetters }, id) {
    const params = {
      id: id,
      token: rootGetters['user/getToken']
    }

    return new Promise((resolve) => {
      api.deletePlan(params)
        .then(() => {
          commit('deleteDone')
          resolve()
        })
    })
  },
  updateTitle ({ commit }, title) {
    commit('setTitle', title)
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  deleteDone () {},
  setTitle (state, title) {
    state.title = title
  },
  setPlan (state, plan) {
    state.title = plan.title
    state.editable = plan.editable
  },
  setPlans (state, plans) {
    state.all = plans
  },
  saveDone () {},
  setIsUser (state, isUser) {
    state.isUser = isUser
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
